const filters = {};

export function add(hook, callback, options) {
    options = jQuery.extend({delete: false, runs: 0}, options);

    if (typeof filters[hook] === 'undefined') {
        filters[hook] = [];
    }
    filters[hook].push({callback, options});
}

export function apply(hook, value) {
    if (typeof filters[hook] === 'undefined') {
        return value;
    }
    filters[hook].forEach(callback => {
        callback.options.runs += 1;
        value = callback.callback(value, arguments, callback.options);
    });

    filters[hook] = filters[hook].filter(callback => ! callback.options.delete);
    return value;
}

export default {add, apply};